/* Tourance Cocoon - theme js */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    var f = (window.TC && window.TC.moneyFormat) || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]);
  };

  var scrim = null;
  function ensureScrim() {
    if (scrim) return scrim;
    scrim = document.createElement('div');
    scrim.className = 'scrim';
    scrim.addEventListener('click', function () { closeAll(); });
    document.body.appendChild(scrim);
    return scrim;
  }
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    closeAll(true);
    ensureScrim().classList.add('is-open');
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('button, a, input, select');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) {} }
  }
  function closeAll(keepScrim) {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (!keepScrim) {
      if (scrim) scrim.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    closeMega();
  }
  window.TCdrawer = { open: openDrawer, close: closeAll };

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  (function () {
    var bar = $('[data-ann]');
    if (!bar) return;
    var slides = $$('.ann-slide', bar);
    var x = $('.ann-x', bar);
    if (x) x.addEventListener('click', function () { bar.remove(); });
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-on');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-on');
    }, 4200);
  })();

  var hdr = $('[data-header]');
  var openTrigger = null;
  function closeMega() {
    $$('.mega.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    $$('[data-mega-trigger][aria-expanded="true"]').forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    openTrigger = null;
    if (hdr) syncHeader();
  }
  function openMega(trigger) {
    var m = document.getElementById(trigger.getAttribute('data-mega-trigger'));
    if (!m) return;
    closeMega();
    m.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    openTrigger = trigger;
    if (hdr) hdr.classList.remove('is-over');
  }
  function syncHeader() {
    if (!hdr) return;
    var overHero = hdr.hasAttribute('data-over-hero');
    var y = window.scrollY || 0;
    if (y > 8) { hdr.classList.add('is-solid'); hdr.classList.remove('is-over'); }
    else { hdr.classList.remove('is-solid'); if (overHero && !openTrigger) hdr.classList.add('is-over'); }
  }
  if (hdr) {
    syncHeader();
    window.addEventListener('scroll', syncHeader, { passive: true });
    $$('[data-mega-trigger]').forEach(function (t) {
      t.addEventListener('mouseenter', function () { openMega(t); });
      t.addEventListener('focus', function () { openMega(t); });
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (t.getAttribute('aria-expanded') === 'true') closeMega(); else openMega(t);
      });
    });
    hdr.addEventListener('mouseleave', function () { closeMega(); });
    document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    window.addEventListener('resize', function () {
      document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    });
  }

  $$('[data-scroller]').forEach(function (wrap) {
    var track = $('.scroller', wrap);
    if (!track) return;
    $$('[data-scroll]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = b.getAttribute('data-scroll') === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * Math.max(280, track.clientWidth * 0.6), behavior: 'smooth' });
      });
    });
  });

  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var target = $('#cart-drawer [data-cart-inner]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        var n = doc.querySelector('[data-cart-count]');
        if (n) $$('[data-cart-count]').forEach(function (el) { el.textContent = n.textContent.trim(); });
      });
  }
  window.TCcart = { refresh: refreshCart };

  function postCart(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-line-change]');
    if (q) {
      e.preventDefault();
      var line = q.getAttribute('data-line');
      var to = parseInt(q.getAttribute('data-line-change'), 10);
      q.disabled = true;
      postCart(window.Shopify.routes.root + 'cart/change.js', { line: parseInt(line, 10), quantity: to })
        .then(refreshCart);
      return;
    }
    var add = e.target.closest('[data-quick-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-quick-card]');
      var sel = card ? card.querySelector('select') : null;
      var id = sel ? sel.value : add.getAttribute('data-variant');
      if (!id) return;
      add.disabled = true;
      var label = add.textContent;
      add.textContent = 'Adding...';
      postCart(window.Shopify.routes.root + 'cart/add.js', { items: [{ id: parseInt(id, 10), quantity: 1 }] })
        .then(refreshCart)
        .then(function () { add.disabled = false; add.textContent = label; });
    }
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-quick-card] select');
    if (!s) return;
    var btn = s.closest('[data-quick-card]').querySelector('[data-quick-add]');
    if (btn) btn.disabled = !s.value;
  });

  $$('[data-product-form]').forEach(function (form) {
    var data = null;
    var holder = $('[data-variants]', form);
    try { data = JSON.parse(holder.textContent); } catch (err) { return; }
    var idInput = $('[name="id"]', form);
    var btn = $('[data-atc]', form);
    var root = form.closest('[data-product-root]') || document;
    var priceEl = $('[data-price]', root);
    var showPrice = form.getAttribute('data-price-in-button') === 'true';

    function current() {
      var chosen = {};
      $$('[data-opt]', form).forEach(function (i) { if (i.checked) chosen[i.getAttribute('data-opt')] = i.value; });
      for (var k = 0; k < data.length; k++) {
        var ok = true;
        for (var ix = 0; ix < data[k].options.length; ix++) {
          if (chosen['o' + (ix + 1)] !== data[k].options[ix]) { ok = false; break; }
        }
        if (ok) return data[k];
      }
      return null;
    }
    function paint() {
      var v = current();
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      $$('[data-opt-label]', form).forEach(function (el) {
        var ix = parseInt(el.getAttribute('data-opt-label'), 10);
        el.textContent = v.options[ix - 1] || '';
      });
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
          ? '<s class="was">' + money(v.compare_at_price) + '</s><span class="now">' + money(v.price) + '</span>'
          : money(v.price);
      }
      btn.disabled = !v.available;
      btn.textContent = !v.available ? 'Sold out' : (showPrice ? 'Add to bag — ' + money(v.price) : 'Add to bag');
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    $$('[data-opt]', form).forEach(function (i) { i.addEventListener('change', paint); });
    paint();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = current();
      if (!v || !v.available) return;
      btn.disabled = true;
      var prev = btn.textContent;
      btn.textContent = 'Adding...';
      var qty = $('[name="quantity"]', form);
      postCart(window.Shopify.routes.root + 'cart/add.js', {
        items: [{ id: v.id, quantity: qty ? (parseInt(qty.value, 10) || 1) : 1 }]
      }).then(function () {
        return refreshCart();
      }).then(function () {
        btn.disabled = false; btn.textContent = prev;
        openDrawer('cart-drawer');
      }).catch(function () { btn.disabled = false; btn.textContent = prev; });
    });

    $$('[data-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('[name="quantity"]', form);
        if (!input) return;
        var n = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, n);
        var out = $('[data-qty-out]', form);
        if (out) out.textContent = input.value;
      });
    });
  });

  (function () {
    var quiz = $('[data-quiz]');
    if (!quiz) return;
    var steps = $$('[data-quiz-step]', quiz);
    var pips = $$('[data-quiz-pip]');
    var answers = [];
    function show(n) {
      steps.forEach(function (s, i) { s.hidden = i !== n; });
      pips.forEach(function (p, i) { p.classList.toggle('on', i <= n); });
    }
    quiz.addEventListener('click', function (e) {
      var o = e.target.closest('[data-quiz-value]');
      if (o) {
        var step = parseInt(o.closest('[data-quiz-step]').getAttribute('data-quiz-step'), 10);
        answers[step] = o.getAttribute('data-quiz-value');
        if (step + 1 < steps.length) { show(step + 1); }
        else {
          var target = o.getAttribute('data-quiz-result');
          window.location.href = target || quiz.getAttribute('data-quiz-base') || '/collections/all';
        }
        return;
      }
      if (e.target.closest('[data-quiz-back]')) {
        var cur = 0;
        steps.forEach(function (s, i) { if (!s.hidden) cur = i; });
        if (cur > 0) show(cur - 1);
      }
    });
    show(0);
    if (location.search.indexOf('modal=quiz') > -1) openDrawer('quiz-drawer');
  })();

  (function () {
    var input = $('[data-search-input]');
    var out = $('[data-search-results]');
    if (!input || !out) return;
    var t = null;
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(function () {
        var url = window.Shopify.routes.root + 'search/suggest?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=8' +
          '&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,vendor' +
          '&section_id=search-results';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var frag = doc.querySelector('[data-search-inner]');
            out.innerHTML = frag ? frag.innerHTML : '';
          });
      }, 220);
    });
  })();
})();
